import LectureLessonResourceModel from '../../generated/types/model/resource/LectureLessonResourceModel';

export default class LectureLessonResourceViewModel extends LectureLessonResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
